import { z } from 'zod'

import { WidgetTypes } from 'apps/growthTools/models/Widget/constants'
import { ChannelType } from 'common/core/constants/ChannelType'
import { TriggerType } from 'common/flow/constants/TriggerType'
import { KeywordRuleSchema } from 'shared/api/requests/keywords/schemas'

const ProtoKeywordSchema = z.object({
  trigger_type: z.literal(TriggerType.KEYWORD),
  channel: z.enum(ChannelType),
  keywords: z.array(KeywordRuleSchema).optional(),
})

const ProtoIntentSchema = z.object({
  trigger_type: z.literal(TriggerType.AI_INTENT),
  channel: z.enum(ChannelType),
  intents: z.array(z.string()).optional(),
})

const ProtoCgtSchema = z.object({
  trigger_type: z.literal(TriggerType.WIDGET),
  widget_type: z.literal(WidgetTypes.FEED_COMMENT_TRIGGER),
  channel: z.enum(ChannelType),
  caption: z.string(),
})

const ProtoStoryReplySchema = z.object({
  trigger_type: z.literal(TriggerType.WIDGET),
  widget_type: z.literal(WidgetTypes.INSTAGRAM_STORY_REPLY),
  channel: z.literal(ChannelType.INSTAGRAM),
  caption: z.string(),
})

const ProtoLiveCommentSchema = z.object({
  trigger_type: z.literal(TriggerType.WIDGET),
  widget_type: z.literal(WidgetTypes.INSTAGRAM_LIVE_COMMENT_REPLY),
  channel: z.literal(ChannelType.INSTAGRAM),
  caption: z.string(),
})

const ProtoRefUrlSchema = z.object({
  trigger_type: z.literal(TriggerType.WIDGET),
  widget_type: z.literal(WidgetTypes.MESSENGER_REF_URL),
  channel: z.union([
    z.literal(ChannelType.FB),
    z.literal(ChannelType.WHATSAPP),
    z.literal(ChannelType.TELEGRAM),
  ]),
  caption: z.string(),
})

export const ProtoTriggerSchema = z.union([
  ProtoKeywordSchema,
  ProtoIntentSchema,
  ProtoCgtSchema,
  ProtoStoryReplySchema,
  ProtoLiveCommentSchema,
  ProtoRefUrlSchema,
])

export type ProtoKeyword = z.infer<typeof ProtoKeywordSchema>
export type ProtoIntent = z.infer<typeof ProtoIntentSchema>
export type ProtoCgt = z.infer<typeof ProtoCgtSchema>
export type ProtoStoryReply = z.infer<typeof ProtoStoryReplySchema>
export type ProtoLiveComment = z.infer<typeof ProtoLiveCommentSchema>
export type ProtoRefUrl = z.infer<typeof ProtoRefUrlSchema>
export type ProtoTrigger = z.infer<typeof ProtoTriggerSchema>
